import { createSystem, defaultConfig, defineConfig, defineRecipe, defineSlotRecipe, defineTokens } from "@chakra-ui/react";

const customConfig = defineConfig({
  theme: {
    tokens: defineTokens({
      colors: {
        primary: { value: "#33324D" },
        text: { value: "#33324D" },
        heading: { value: "#33324D" },
        pink: {
         700: { value: "#FC3C5E" },
        },
        gray: {
          600: { value: "#8B8B8B" },
        }
      },
      fonts: {
        body: { value: "Roboto, sans-serif" }
      },
      fontSizes: {
        body: { value: "16px" }
      }
    }),
    recipes: {
      button: defineRecipe({
        base: {
          padding: "10px",
          borderRadius: "4px",
          fontSize: "14px",
          fontWeight: 500,
          border: "none",
          cursor: "pointer",
          transition: "background 0.2s",
        },
        variants: {
          visual: {
            solid: {
              background: "#fc3c5ecc",
              color: "#fff",
              _hover: {
                background: "#e22b4d",
              },
            },
            subtle: {
              background: "#8b8b8b",
              color: "#fff",
              _hover: {
                background: "#6e6e6e",
              },
            },
            ghost: {
              background: "transparent",
              color: "#8b8b8b",
              _hover: {
                background: "rgba(0, 0, 0, 0.05)",
              },
              "& svg": {
                color: "#8b8b8b",
                width: "24px",
                height: "24px",
              },
              "&.selected": {
                color: "#383838",
                "& svg": {
                  color: "#ff002d"
                }
              }
            }
          }
        },
        defaultVariants: {
          visual: "solid",
        }
      }),
      heading: defineRecipe({
        base: {
          color: "{colors.heading}"
        },
        variants: {
          size: {
            lg: {
              fontSize: "32px",
              fontWeight: 400,
              letterSpacing: "0.15px",
            }
          }
        }
      }),
      text: defineRecipe({
        base: {
          color: "{colors.text}"
        }
      }),
      input: defineRecipe({
        base: {
          height: "48px",
          padding: "12px 16px",
          paddingInline: "16px",
          paddingInlineStart: "16px",
          paddingInlineEnd: "16px",
          fontSize: "14px"
        }
      }),
    },
    slotRecipes: {
      /*table: defineSlotRecipe({
        className: 'default-table',
        slots: ['columnHeader', 'cell', 'root', 'row'],
        base: {
          root: {
            width: '100%',
          },
          columnHeader: {
            padding: '16px',
            height: '65px',
          },
          row: {
            color: '#8b8b8b',
          },
          cell: {
            padding: '16px',
            height: '56px',
          }
        }
      }),*/
      radio: defineSlotRecipe({
        className: 'default-radio-group',
        slots: ['itemControl', 'itemText'],
        base: {
          itemText: {
            color: 'red',
          },
          itemIndicator: {
            borderColor: '#CDCDDC',
            _checked: {
              borderColor: '#FC3C5E',
              background: '#FC3C5E',
            },
          }
        },
        defaultVariants: {
          visual: 'outline',
        }
      }),
      tabs: defineSlotRecipe({
        className: 'default-tabs',
        slots: ['trigger', 'indicator'],
        base: {
          indicator: {
            background: '#C3C3C333',
          },
          trigger: {
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: '600',
            width: '32px',
            height: '32px',
            padding: '0',
            justifyContent: 'center',
            color: '#8B8B8B',
            _selected: {
              borderRadius: '5px',
              color: '#FC3C5E',
              background: '#C3C3C333',
            }
          }
        }
      }),
      switch: defineSlotRecipe({
        className: 'default-switch',
        slots: ['root', 'control', 'indicator'],
        variants: {
          variant: {
            default: {
              root: {
                width: '20px',
                height: '10px',
              },
              control: {
                width: '20px',
                height: '10px',
                backgroundColor: '#FC3C5E',
                _checked: {
                  backgroundColor: '#5FCBA3',
                },
              },
              thumb: {
                margin: '2px',
                width: '6px',
                height: '6px',
                backgroundColor: '#fff',
                _checked: {
                  translate: '10px 0'
                }
              },
            },
          },
        },
        defaultVariants: {
          variant: 'default',
        },
      }),
      toast: defineSlotRecipe({
        className: 'default-toast',
        slots: ['root', 'title', 'description', 'actionTrigger'],
        base: {
          root: {
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            padding: '16px',
            border: '1px solid #e2e8f0',
            maxWidth: '400px',
          },
          title: {
            fontSize: '16px',
            fontWeight: '600',
            color: '#33324D',
            marginBottom: '4px',
          },
          description: {
            fontSize: '14px',
            color: '#8B8B8B',
            lineHeight: '1.4',
          },
          actionTrigger: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#FC3C5E',
            textDecoration: 'none',
            _hover: {
              textDecoration: 'underline',
            },
          },
        },
        variants: {
          variant: {
            success: {
              root: {
                borderLeft: '4px solid #48BB78',
              },
            },
            error: {
              root: {
                borderLeft: '4px solid #F56565',
              },
            },
            warning: {
              root: {
                borderLeft: '4px solid #ED8936',
              },
            },
            info: {
              root: {
                borderLeft: '4px solid #4299E1',
              },
            },
          },
        },
        defaultVariants: {
          variant: 'info',
        },
      }),
    },
  },
});

export const system = createSystem(defaultConfig, customConfig);